import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, FileText, Loader2 } from 'lucide-react';
interface ContextPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  task: {
    id: string;
    name: string;
    status: string;
  } | null;
}
export function ContextPopover({
  isOpen,
  onClose,
  task
}: ContextPopoverProps) {
  if (!task) return null;
  return <AnimatePresence>
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/20 z-50" />

          {/* Popover */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.15
      }} className="fixed top-24 right-[47%] w-[400px] bg-surface-900 border border-surface-600 rounded-xl shadow-2xl z-50 max-h-[70vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-surface-600">
              <h3 className="font-semibold text-text-primary">Context & Files</h3>
              <button onClick={onClose} className="text-text-muted hover:text-text-primary transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              <div>
                <h4 className="text-sm font-medium text-text-secondary mb-3">
                  Input Files
                </h4>
                <div className="space-y-2">
                  {['requirements.md', 'api-schema.json', 'legacy-code.ts'].map((file, i) => <div key={i} className="flex items-center gap-3 p-2.5 rounded-lg bg-surface-800/50 border border-surface-600 hover:border-surface-500 transition-colors cursor-pointer group">
                        <FileText className="w-4 h-4 text-text-muted group-hover:text-primary-400 transition-colors flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                          <div className="text-sm text-text-primary group-hover:text-text-primary transition-colors truncate">
                            {file}
                          </div>
                          <div className="text-xs text-text-muted">
                            2kb • 2h ago
                          </div>
                        </div>
                      </div>)}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-medium text-text-secondary mb-3">
                  Outputs
                </h4>
                {task.status === 'completed' ? <div className="space-y-2">
                    {['analysis-report.md', 'implementation-plan.md'].map((file, i) => <div key={i} className="flex items-center gap-3 p-2.5 rounded-lg bg-surface-800/50 border border-surface-600 hover:border-surface-500 transition-colors cursor-pointer group">
                          <div className="w-7 h-7 rounded bg-primary-500/10 flex items-center justify-center text-primary-400 flex-shrink-0">
                            <FileText className="w-3.5 h-3.5" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="text-sm text-text-primary group-hover:text-text-primary transition-colors truncate">
                              {file}
                            </div>
                            <div className="text-xs text-text-muted">
                              Just now
                            </div>
                          </div>
                        </div>)}
                  </div> : <div className="flex flex-col items-center justify-center py-6 text-center">
                    <div className="w-10 h-10 rounded-full bg-surface-800 flex items-center justify-center mb-2">
                      <Loader2 className="w-5 h-5 text-text-muted animate-spin" />
                    </div>
                    <p className="text-text-secondary text-xs">
                      Waiting for completion...
                    </p>
                  </div>}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}